// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.global-keyboard[data-v-2ddd3d02] {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 90000;\n}\n[dir=ltr] .global-keyboard[data-v-2ddd3d02] {\n  left: 0;\n}\n[dir=rtl] .global-keyboard[data-v-2ddd3d02] {\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
